"use strict";
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    dataLayerPush: function() {
        return dataLayerPush;
    },
    loadContainers: function() {
        return loadContainers;
    }
});
module.exports = __toCommonJS(src_exports);
// src/utils.ts
var STR_UNDEFINED = "undefined";
var isWindowDefined = (typeof window === "undefined" ? "undefined" : _typeof(window)) != STR_UNDEFINED;
var IS_SERVER = !isWindowDefined || "Deno" in window;
// src/legacy/loadJS.ts
var onError = function(containerId) {
    console.log("==> can not load container ".concat(containerId));
};
var scriptGtm = function scriptGtm(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        "gtm.start": /* @__PURE__ */ new Date().getTime(),
        event: "gtm.js"
    });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.onerror = function() {
        return onError(i);
    };
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    j.addEventListener("load", function() {
        var _ge = new CustomEvent("gtm_loaded", {
            bubbles: true
        });
        d.dispatchEvent(_ge);
    });
    f.parentNode.insertBefore(j, f);
};
function loadJS(containerId) {
    try {
        scriptGtm(window, document, "script", "dataLayer", containerId);
    } catch (e) {
        console.log("==> can not add script GTM container");
        console.log(e);
    }
}
// src/legacy/loadContainers.ts
function loadContainers() {
    for(var _len = arguments.length, containerIds = new Array(_len), _key = 0; _key < _len; _key++){
        containerIds[_key] = arguments[_key];
    }
    if (!IS_SERVER && Array.isArray(containerIds) && containerIds.length > 0) {
        containerIds.forEach(function(containerId) {
            loadJS("".concat(containerId));
        });
        return true;
    }
    return false;
}
// src/legacy/dataLayerPush.ts
function dataLayerPush(payload) {
    var _window_dataLayer;
    if (window.google_tag_manager && typeof ((_window_dataLayer = window.dataLayer) === null || _window_dataLayer === void 0 ? void 0 : _window_dataLayer.push) === "function") {
        window.dataLayer.push(payload);
    } else {
        window.addEventListener("gtm_loaded", function() {
            window.dataLayer.push(payload);
        }, {
            once: true
        });
    }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    dataLayerPush: dataLayerPush,
    loadContainers: loadContainers
});
